import styled from 'styled-components';
import { ReactComponent as Icon } from '../icons/errorIcon.svg';

export const TermsTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 50px 0 80px 0;
`;

export const TermsPlainTextWrapper = styled.div`
  text-align: left;
  margin: 0 10%;
`;

export const TermsSubTitle = styled.div`
  text-align: left;
  margin: 25px 0;
  font-weight: bold;
`;

export const TermsTitle = styled.div`
  text-align: center;
  margin: 25px 0;
`;

export const TermsPlainText = styled.div`
  line-height: 20px;
  margin-bottom: 12px;
`;

export const BorderedTableCell = styled.td`
  border: 1px solid black;
  padding: 10px;
  align-content: start;
`;

export const BorderedTableCellBold = styled(BorderedTableCell)`
  font-weight: bold;
`;

export const StyledTable = styled.table`
  border: 1px solid black;
  border-collapse: collapse;
  margin: 30px 0;
`;

export const Footer = styled.div`
  line-height: 20px;
  margin-top: 50px;
`;

export const Paragraph = styled.div`
  line-height: 20px;
  margin-left: 50px;
  margin-top: 10px;
`;

export const SubParagraph = styled.div`
  line-height: 20px;
  margin-left: 100px;
  margin-top: 20px;
`;

export const IndentedParagraph = styled(TermsPlainText)`
  text-indent: -50px;
  padding-left: 50px;
  text-align: justify;
`;

export const ErrorStyledIcon = styled(Icon)`
  margin-bottom: 15px;
`;

export const ErrorPageContainer = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: 'Roboto', Arial, sans-serif;
`;

export const ErrorContentContainer = styled.div`
  margin-top: -200px;
  padding: 15px;
  font-size: 20px;
  font-weight: normal;
  color: rgb(84, 87, 90);

  p {
    margin: 0.5em 0;
  }
`;
